import { Dropdown } from 'primereact/dropdown';
import React, { useEffect, useState } from 'react';

import MessageInfo from '../../../components/messageInfo/MessageInfo';
import { useGetSorecardRolesQuery } from '../../../pages/compensation/compensationSlice';
import { Person } from '../../../utils/types';
import { ScoreCardPropTypes } from '../types';

const ScoreCardRoles = ({ inputYear, inputMonth, inputScorecardVersion }: ScoreCardPropTypes) => {
    const [sorecardRolesList, setSorecardRolesList] = useState<Person[]>([]);
    const [scorecardRolesDropDownValue, setScorecardRolesDropDownValue] = useState({
        name: 'Team Lead',
        code: 2,
    });

    const scorecardRolesDropDown = [
        { name: 'Team Lead', code: 2 },
        { name: 'Manager', code: 3 },
    ];

    const { data: sorecardRolesData } = useGetSorecardRolesQuery(
        {
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: inputScorecardVersion,
            applicationRoleId: scorecardRolesDropDownValue?.code,
        },
        {
            skip: !inputYear || !inputMonth || !inputScorecardVersion || !scorecardRolesDropDownValue?.code,
        }
    );

    useEffect(() => {
        if (sorecardRolesData?.data?.length > 0) {
            const data = sorecardRolesData?.data;
            const sortedData = [...data].sort((a, b) => a.last_name.localeCompare(b.last_name));
            setSorecardRolesList(sortedData);
        } else {
            setSorecardRolesList([]);
        }
    }, [inputYear, inputMonth, inputScorecardVersion, sorecardRolesData]);

    const onScorecardRolesChange = (e: any) => {
        setScorecardRolesDropDownValue(e.value);
    };

    if (sorecardRolesList.length > 0) {
        return (
            <div className="card shadow border-0 h-100 borderRadius10">
                <div className="card-body">
                    {/* <h6 className="card-title">Scorecard Roles</h6>
                    <hr className="mt-2" /> */}
                    <Dropdown
                        optionLabel="name"
                        placeholder="Select"
                        className="custom-dropdown"
                        disabled={inputScorecardVersion === null}
                        value={scorecardRolesDropDownValue}
                        options={scorecardRolesDropDown}
                        onChange={onScorecardRolesChange}
                    />
                    <div
                        className="row"
                        style={{ overflowX: 'auto', maxHeight: '370px', margin: 'auto', fontSize: 'small' }}
                    >
                        {sorecardRolesList?.map((item: any) => (
                            <div
                                key={item.last_name + '-' + item.first_name}
                                className="row mt-3 mr-3 col-md-12"
                            >
                                {` ${item.last_name + ', ' + item.first_name}`}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="col-12">
            <h6 className="card-title ms-3 mt-2">Scorecard Roles</h6>
            <hr className="mt-2" />
            <MessageInfo
                title="No results found."
                message="Try adjusting the month or scorecard filter above."
                rowHeight="308px"
            />
        </div>
    );
};

export default ScoreCardRoles;
